import $ from 'jquery';
import BaseUploadView from '../../pages/fttc2/BaseUploadView';
import { parseFilename } from '../../../home24-shared/core/Utils';
import * as registry from '../../../home24/core/registry';
import * as lightbox from '../../../home24/helpers/lightbox';

export default BaseUploadView.extend({
  events: {
    'click .change-type-action .action': 'onReclamationTypeClick',
    'change .reclamation-type-input': 'onReclamationTypeChange',
    'click .different-complains label': 'onDifferentComplainsClick',
    'change .reclamation-category-input': 'onCategoryChange',
    'change .reclamation-reason-input': 'onReasonChange',
    'click .fttc2-upload': 'onUploadOpenClick',
    'click .js-file-remove': 'onFileRemoveClicked'
  },

  selectors: {
    reclamationCategoryInput: '.reclamation-category-input',
    reclamationTypeSelect: '.reclamation-type-input',
    reclamationReasonInput: '.reclamation-reason-input',
    reclamationPictureUploadWrapper: '.fttc2-download-holder',
    reclamationPictureUploadLabel: '.js-fttc2-file-description'
  },

  $uploadParent: null,
  $popup: null,
  reasonOptions: {},

  messageBox: null,

  initialize: function(options) {
    this.commentView = options.commentView;
    this.$popup = options.$popup;
    this.$uploadTemplate = options.$uploadTemplate;
    this.messageBox = options.messageBox;
    this.isBusinessAccount = Boolean(registry.get('isBusinessAccount'));

    this.model.set({
      differentComplainsVisible: this.$('.different-complains input').prop(
        'checked'
      ),
      type: this.$(this.selectors.reclamationTypeSelect).val()
    });

    this.listenTo(
      this.model,
      'change:differentComplainsVisible',
      this.onDifferentComplainsModelChange
    );

    this.repositionExpandedVerticalLine();

    /*
         Trigger view elements
         */
    this.onReclamationTypeChange();
  },

  /**
   * Method is executed after uploaded file has been deleted from view
   */
  postFileRemove: function() {
    this.handleEmptyDownloadSections();
    this.repositionExpandedVerticalLine();
  },

  onUploadOpenClick: function(event) {
    event.preventDefault();

    this.$uploadParent = $(event.currentTarget).closest('.reason-parent');

    lightbox
      .setConfig({
        $dialog: this.$popup,
        className: 'upload-dialog'
      })
      .open();

    var $content = lightbox.getLightboxContainer();

    $content.find('[name=sku]').val(this.$uploadParent.attr('data-sku'));

    /*
        Unbind old event and bind new for upload form
         */
    $content.off('.upload');

    /*
        Bind new events for this instance of file upload dialog
         */
    $content.on(
      'change.upload',
      '.fileUploadField',
      $.proxy(this.onFileSelected, this)
    );
    $content.on(
      'click.upload',
      '.js-upload-submit',
      $.proxy(this.onUploadSubmit, this)
    );

    if (!$.browser.msie) {
      $content.on(
        'click.upload',
        '.photo-filename',
        $.proxy(this.onFilenameClick, this)
      );
    }
  },

  getUploadContainer: function() {
    return this.$uploadParent;
  },

  prepareUploadManager: function(uploadManager) {
    var $content = lightbox.getLightboxContainer();

    uploadManager.$scope = this.$el;

    uploadManager
      .setForm($content.find('form').first())
      .setInput($content.find('.fileUploadField').first())
      .validate();
  },

  onUploadSubmit: function(event) {
    event.preventDefault();
    this.startUpload(event);
  },

  postUploadSuccess: function() {
    this.repositionExpandedVerticalLine();
  },

  postUploadFailure: function() {
    this.repositionExpandedVerticalLine();
  },

  postInsertTemplate: function($cloned) {
    this.$uploadParent
      .find('.fttc2-file-box')
      .first()
      .removeClass('is-hidden');

    if (!this.$uploadParent.hasClass('is-group-parent')) {
      $cloned.attr(
        'data-for',
        this.$uploadParent.find('.fttc2-uploaded-files').attr('data-target')
      );
    }

    this.repositionExpandedVerticalLine();
  },

  onFilenameClick: function(event) {
    event.preventDefault();
    lightbox
      .getLightboxContainer()
      .find('[name=fileUpload]')
      .trigger('click');
  },

  onFileSelected: function(event) {
    this.startUpload(event);
  },

  validateImages: function() {
    if (
      this.reasonOptions.imageUpload &&
      this.$('.fttc2-uploaded-files').children().length === 0
    ) {
      this.model.set('imagesValid', false);
    }
  },

  validateSelects: function() {
    var $list = this.$(
      '.reclamation-category-input, .reclamation-reason-input'
    );
    var i;

    $list.removeClass('invalid');

    for (i = 0; i < $list.length; i++) {
      var $element = $list.eq(i);

      if (
        $element.is(':visible') &&
        $element.is(':enabled') &&
        !$element.find('option:selected').val()
      ) {
        $element.addClass('invalid');
        this.model.set('selectsValid', false);
      }
    }

    var reclamationTypeValue = this.$(
      this.selectors.reclamationTypeSelect
    ).val();

    if (
      this.isBusinessAccount &&
      (reclamationTypeValue === 'cancel' || reclamationTypeValue === 'return')
    ) {
      this.model.set('b2bCancellationValid', false);
    }
  },

  preselect: function() {
    this.$('[data-preselected-value]').each(function() {
      var $this = $(this);

      $this.val($this.data('preselected-value')).trigger('change');
    });
  },

  onCategoryChange: function(event) {
    var $cT = $(event.currentTarget);
    var $parent = this.getReasonParent($cT);
    var $input = $parent.find(this.selectors.reclamationReasonInput).eq(0);
    var reclamationType = this.model.get('type');
    var value = $cT.val();

    if (value) {
      this.populateReasonSelects(
        $parent,
        this.model.getReasons(reclamationType, value),
        '.reclamation-reason-input:first'
      );

      // set currently chosen children for future reference
      $parent.attr(
        'data-current-reclamation-path',
        reclamationType + '.' + value
      );

      $cT.removeClass('invalid');
      $input.prop('disabled', false);
      $input.trigger('change');
      $parent.find('.reason-holder').addClass('active');
    } else {
      $input.val($input.find('option:first').val());
      $input.trigger('change');
      $input.prop('disabled', true);
      $parent.find('.reason-holder').removeClass('active');
    }
  },

  onReasonChange: function(event) {
    var $cT = $(event.currentTarget);
    var $parent = this.getReasonParent($cT);

    $cT.removeClass('invalid');

    // set currently chosen children for future reference
    var currentReclamationPath = $parent.attr('data-current-reclamation-path');

    if (currentReclamationPath) {
      var pathAsArray = currentReclamationPath.split('.');

      $parent.attr(
        'data-current-reclamation-path',
        pathAsArray[0] + '.' + pathAsArray[1] + '.' + $cT.val()
      );
    }

    this.showInputSet($parent);

    // DON'T DELETE! We need it for android's chrome. Without it:
    // option dropdown menu, user selection will not be displayed until page is touched one more time
    $(event.currentTarget).css({ color: '#333' });
    $('body').trigger('touch');
  },

  /**
   * show correct inputs set based on reclamation path
   * check http://confluence.home24.de/display/pm/Reclamation+Status for details
   * @param {$} $parent
   */
  showInputSet: function($parent) {
    this.reasonOptions = this.model.getReasonOptions(
      $parent.attr('data-current-reclamation-path')
    );

    this.hideConditionalElements($parent);

    this.commentNotRequired($parent);
    this.commentView.updateLabel(this.reasonOptions.commentId);
    this.commentView.show();

    if (this.reasonOptions.imageUpload) {
      this.showSpecificPictureLabel($parent, this.reasonOptions.imageId);
      this.showPictureUpload($parent);
    }

    this.repositionExpandedVerticalLine();
  },

  commentNotRequired: function($el) {
    this.model.get('commentRequired')[
      $el.data('index-article') + '_' + $el.data('index-piece')
    ] = false;
  },

  commentRequired: function($el) {
    this.model.get('commentRequired')[
      $el.data('index-article') + '_' + $el.data('index-piece')
    ] = true;
  },

  showPictureUpload: function($parent) {
    $parent
      .find(this.selectors.reclamationPictureUploadWrapper)
      .first()
      .removeClass('is-hidden');
  },

  showSpecificPictureLabel: function($parent, imageId) {
    var id = 1;

    if (imageId) {
      id = imageId;
    }

    $parent
      .find(this.selectors.reclamationPictureUploadLabel)
      .text(this.model.get('translations').images[id]);
  },

  hideConditionalElements: function($el) {
    $el
      .find(this.selectors.reclamationPictureUploadWrapper)
      .first()
      .addClass('is-hidden');
  },

  /**
   * Method finds parent container for return/reclamation reason input (any kind of input)
   * @param {Object} $element select box which value has been changed
   * @return {Object}
   */
  getReasonParent: function($element) {
    return $element.closest('.reason-parent');
  },

  onDifferentComplainsClick: function() {
    this.model.set({
      differentComplainsVisible: !this.model.get('differentComplainsVisible')
    });
  },

  onDifferentComplainsModelChange: function() {
    var bState = this.model.get('differentComplainsVisible');
    var $label = this.$('.different-complains label');
    var $bottom = this.$('.fttc2-bottom-block');
    var $target;

    this.$('.js-different-checkbox').prop('checked', bState);

    if (bState) {
      this.$('.top-block').addClass('is-hidden');
      this.$('.fttc2-bottom-block').removeClass('is-hidden');

      $label.html($label.attr('data-label-expanded'));

      /*
            Move uploaded files to first child
             */
      this.$('.fttc2-uploaded-files')
        .first()
        .find('li')
        .each(function() {
          var $this = $(this);
          var dataFor = $this.attr('data-for');

          if (dataFor && dataFor.length > 0) {
            $target = $bottom.find('[data-target="' + dataFor + '"]');
          } else {
            $target = $bottom.find('.fttc2-uploaded-files').first();
          }

          $target.append(this);
        });
    } else {
      this.$('.top-block').removeClass('is-hidden');
      this.$('.fttc2-bottom-block').addClass('is-hidden');

      $label.html($label.attr('data-label-collapsed'));

      /*
            Move from different to top section
             */
      $target = this.$('.fttc2-uploaded-files').first();

      $bottom.find('.fttc2-uploaded-files li').each(function() {
        $target.append(this);
      });

      this.clearDifferentComplains();
    }

    this.handleEmptyDownloadSections();
    this.repositionExpandedVerticalLine();
  },

  handleEmptyDownloadSections: function() {
    this.$('.fttc2-uploaded-files').each(function() {
      var $this = $(this);
      var $parent = $this.closest('.fttc2-file-box');

      if ($this.find('li').length > 0) {
        $parent.removeClass('is-hidden');
      } else {
        $parent.addClass('is-hidden');
      }
    });
  },

  /**
   * Remove values from different complains window.
   */
  clearDifferentComplains: function() {
    var $categorySelectInput = this.$('.reason-category select');
    var $textInput = this.$('input[type="text"]');
    var countTextInput = $textInput.length;
    var i;
    var $select;
    var $firstChild;

    $textInput.val('');

    for (i = 0; i < countTextInput; i++) {
      $select = $categorySelectInput.eq(i);
      $firstChild = $select.children(':first-child');

      $select.val($firstChild.val());
      $select.trigger('change');
    }
  },

  repositionExpandedVerticalLine: function() {
    var $block = this.$('.fttc2-bottom-block');

    /*
        If there is no bottom block, there is no reason to reposition lines, since they do not exists
         */
    if ($block.length === 0) {
      return;
    }

    var $line = $block.find('>.vertical-line');
    var $lastBlock = $block.find('.fttc2-column').last();
    var $horizontalLine = $lastBlock.find('>.ie-before');

    $line.css(
      'height',
      $lastBlock.offset().top -
        $block.offset().top +
        parseInt($horizontalLine.css('top'), 10) -
        +parseInt($line.css('top'), 10)
    );
  },

  /**
   * Show select box that allows to choose different reclamation type.
   */
  onReclamationTypeClick: function() {
    this.$('.reclamation-type-label').addClass('is-hidden');
    this.$('.reclamation-type-input').removeClass('is-hidden');
    this.$('.change-type-action').addClass('is-hidden');
  },

  onReclamationTypeChange: function() {
    this.model.set({
      type: this.$(this.selectors.reclamationTypeSelect).val()
    });

    this.populateReasonSelects(
      this.$el,
      this.model.getCategories(this.model.get('type')),
      this.selectors.reclamationCategoryInput
    );
    this.$(this.selectors.reclamationCategoryInput).trigger('change');
  },

  /**
   * Method recreates options for all select in $container matching selectorId with data passed in jsonData parameter
   *
   * @param {Object} $container $ object of reclamation reason parent
   * @param {Object} jsonData reclamation reason tree structure
   * @param {String} selector selector of select to recreate
   */
  populateReasonSelects: function($container, jsonData, selector) {
    var $selects = $container.find(selector);
    var len = $selects.length;
    var html = this.buildSelectHtml(jsonData);
    var i;

    for (i = 0; i < len; i++) {
      this.populateReasonSelect($selects.eq(i), html);
    }
  },

  /**
   * Method recreates select options using passed html. It preserves first option
   *
   * @param {Object} $target jQuery object pointing at select that needs to be repopulated
   * @param {String} html html of inserted options
   */
  populateReasonSelect: function($target, html) {
    var $firstChild = $target.children(':first-child');

    $firstChild.detach();
    $target.html(html);
    $target.prepend($firstChild);

    $target.val($target.find('option:first').val());
  },

  /**
   * Method creates and returns HTML options for reclamation category and reason selects based on passed tree structure
   * @param {Object} data fragment of reclamation reason structure tree passed from backend
   * @return {String}
   */
  buildSelectHtml: function(data) {
    var html = '';
    var key;

    if (!data.children) {
      return '';
    }

    for (key in data.children) {
      /* istanbul ignore else */
      if (data.children.hasOwnProperty(key)) {
        html +=
          '<option value="' +
          key +
          '">' +
          data.children[key].name +
          '</option>';
      }
    }

    return html;
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/fttc2/Step2ArticleView.js
 **/